module.exports = {
	fileUploadDirectory: process.env.FILE_UPLOAD_DIRECTORY,
	streamingDomain: "https://b2bstreaming.justdial.com/streams",
	thumbnailDomain: "https://image1.jdomni.in/b2bvideothumbnail",
	uploadApiDomain: "https://b2bstreaming.justdial.com"
};